import React from 'react'

function WithDraggableList(WrappedComponent) {
  return class extends React.Component {
    constructor() {
      super()

      this.state = {
        initialPoint: 0,
        isMouseDown: false,
        previousOffset: 0,
        currentDiff: 0,
        isListFitting: true,
      }

      this.listRef = React.createRef()
      this.listWrapperRef = React.createRef()

      this.getCurrentDiff = this.getCurrentDiff.bind(this)
      this.getCurrentTouchDiff = this.getCurrentTouchDiff.bind(this)
      this.handleDown = this.handleDown.bind(this)
      this.handleUp = this.handleUp.bind(this)
      this.handleMove = this.handleMove.bind(this)
      this.onTagClick = this.onTagClick.bind(this)
      this.handleResize = this.handleResize.bind(this)
      this.handleMouseLeave = this.handleMouseLeave.bind(this)
      this.onTagUpdate = this.onTagUpdate.bind(this)
    }

    componentDidMount() {
      this.handleResize()

      window.addEventListener('resize', this.handleResize)
    }

    onTagUpdate() {
      this.handleResize()
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize)
    }

    getCurrentDiff(e) {
      return (this.state.initialPoint - e.clientX)
    }

    getCurrentTouchDiff(e) {
      return (this.state.initialPoint - e.changedTouches[0].clientX)
    }

    handleResize() {
      if (this.listWrapperRef.current.clientWidth < this.listRef.current.clientWidth) {
        this.setState({
          isListFitting: false,
          maxOffset: this.listWrapperRef.current.clientWidth - this.listRef.current.clientWidth,
        })
      } else {
        this.listRef.current.style.left = '0'
      }
    }

    handleDown(e, source) {
      this.setState({
        initialPoint: source === 'touch' ? e.changedTouches[0].clientX : e.clientX,
        isMouseDown: true,
        currentDiff: 0,
      })
    }

    handleMove(e, source) {
      if (this.state.isMouseDown && !this.state.isListFitting && this.listRef) {
        let offset = this.state.previousOffset

        if (source === 'touch') {
          offset += this.getCurrentTouchDiff(e) * -1
        } else {
          offset += this.getCurrentDiff(e) * -1
        }

        if (offset > this.state.maxOffset && offset <= 0) {
          this.listRef.current.style.left = `${offset}px`
        }
      }
    }

    handleUp(e, source) {
      this.setState({
        initialPoint: 0,
        isMouseDown: false,
        previousOffset: parseInt(this.listRef.current.style.left, 10) || 0,
        currentDiff: source === 'touch' ? this.getCurrentTouchDiff(e) : this.getCurrentDiff(e),
      })
    }

    handleMouseLeave(e) {
      if (this.state.isMouseDown && !this.state.isListFitting) {
        this.handleUp(e)
      }
    }

    onTagClick(val) {
      if (Math.abs(this.state.currentDiff) === 0) {
        this.props.redirectTagEvent(val)
      }
    }

    render() {
      return (
        <div
          className="user-profile__tags-wrapper"
          onMouseLeave={this.handleMouseLeave}
          ref={this.listWrapperRef}
        >
          <div
            className="user-profile__tags-container"
            onMouseDown={this.handleDown}
            onMouseUp={this.handleUp}
            onMouseMove={this.handleMove}
            onTouchStart={(e) => { this.handleDown(e, 'touch') }}
            onTouchEnd={(e) => { this.handleUp(e, 'touch') }}
            onTouchMove={(e) => { this.handleMove(e, 'touch') }}
            ref={this.listRef}
          >
            <WrappedComponent
              onClick={this.onTagClick}
              onUpdate={this.onTagUpdate}
              {...this.props}
            />
          </div>
        </div>
      )
    }
  }
}

export default WithDraggableList
